export default {
  lg: 992,
};
